import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import {
  FieldTypes,
  SelectOptionFields,
  TextTypeFields,
  emailField,
  systemDateField,
} from 'drapcode-constant';
import { iconForField } from '../../../common/custom/icon-library';
import {
  moveDefaultCollectionFieldsToEndAndSort,
  phoneNumberCountryCode,
} from '../../../common/utils/api_utils';
import { fileTypes } from '../../../common/formElements/CollectionSectionType';
import CollectionCardView from '../../../common/ui/CollectionCardView';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import CustomRadio from '../../../common/ui/CustomRadio';
import LargeTextExtraSetting from './type/LargeTextExtraSetting';
import MultiDynamicExtraSetting from './type/MultiDynamicExtraSetting';
import BelongsToExtraSetting from './type/BelogsToExtraSetting';
import ReferenceExtraSetting from './type/ReferenceExtraSetting';
import StaticOptionExtraSetting from './type/StaticOptionExtraSetting';
import FileExtraSetting from './type/FileExtraSetting';
import DateExtraSetting from './type/DateExtraSetting';
import CustomUUIDExtraSetting from './type/CustomUUIDExtraSetting';
import {
  CUSTOM_SEPARATOR,
  extractRefFieldForCreateField,
} from '../../../common/utils/field-options';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { getValuesForDefaultField } from '../../../common/utils/collectionConstants';
import TimepickerExtraSetting from './type/TimepickerExtraSetting';
import Col6FormCheck from '../../../common/ui/Col6FormCheck';

const customCss = { cursor: 'pointer', minWidth: '10.5rem', fontSize: '0.8rem' };

const {
  boolean,
  reference,
  file,
  belongsTo,
  static_option,
  large_text,
  dynamic_option,
  date,
  text,
  url,
  number,
  color,
  email,
  tel,
  custom_uuid,
  time_picker,
  markdown,
} = FieldTypes;
export default class FieldFormFields extends Component {
  state = { toggleAdvancedField: false };
  componentDidMount() {
    const { selectedField } = this.props;
    const advancedFields = Object.keys(FieldTypes).filter((key) => FieldTypes[key].advancedOptions);
    if (advancedFields.includes(selectedField)) {
      this.setState({ toggleAdvancedField: true });
    }
  }

  validateRefCollectionId = (value) => {
    let error;
    if (!value) {
      error = 'This field is required';
    }
    return error;
  };

  handleFieldNameChange = (e, setFieldValue) => {
    setFieldValue('fieldTitle.en', e.target.value);
    setFieldValue('placeholder.en', e.target.value);
  };

  //TODO: Need refactoring
  handleDefaultChange = (e, setFieldValue) => {
    setFieldValue('extraFieldSetting.defaultValue', e.target.value);
  };

  //TODO: Need refactoring
  getFieldTypes = () => {
    return Object.keys(FieldTypes)
      .filter((key) => FieldTypes[key].show)
      .sort()
      .map((key) => ({
        value: key,
        label: FieldTypes[key].name,
        sortOrder: FieldTypes[key].sortOrder,
      }));
  };

  //TODO: Need refactoring
  getAdvancedFieldTypes = () => {
    return Object.keys(FieldTypes)
      .filter((key) => FieldTypes[key].advancedOptions)
      .sort()
      .map((key) => ({
        value: key,
        label: FieldTypes[key].name,
        sortOrder: FieldTypes[key].advSortOrder,
      }));
  };

  getFileTypes = () => {
    return fileTypes.map((fileType, key) => {
      return { value: fileType, label: fileType };
    });
  };

  //TODO: Need refactoring
  getFieldOption = (refCollectionId) => {
    if (refCollectionId) {
      const { projectCollections, selectedField } = this.props;
      const isFieldAllowedForLevel2Ref = ['dynamic_option'].includes(selectedField);
      let index = projectCollections.findIndex(function (item, i) {
        return item.collectionName === refCollectionId;
      });
      if (index >= 0) {
        const fields = projectCollections[index].fields.filter(
          (field) =>
            ![
              boolean.id,
              reference.id,
              belongsTo.id,
              static_option.id,
              ...systemDateField,
            ].includes(field.type),
        );

        let collectionFields = [];
        collectionFields = _.cloneDeep(fields);

        if (isFieldAllowedForLevel2Ref) {
          const referenceFields = projectCollections[index].fields.filter((field) =>
            [reference.id].includes(field.type),
          );
          if (referenceFields && referenceFields.length) {
            const extractedRefFields = extractRefFieldForCreateField(
              referenceFields,
              projectCollections,
              index,
            );
            if (extractedRefFields) {
              collectionFields.push(...extractedRefFields);
            }
          }
        }

        return moveDefaultCollectionFieldsToEndAndSort(collectionFields).map((field) => {
          const { refCollection } = field;
          let fieldParentCollectionName = '';
          if (refCollection && Object.keys(refCollection).length) {
            const { childRefCollectionName } = refCollection;
            if (childRefCollectionName) {
              fieldParentCollectionName = childRefCollectionName || '';
            }
          }

          return (
            <option
              key={field._id}
              value={
                fieldParentCollectionName
                  ? `${fieldParentCollectionName}${CUSTOM_SEPARATOR}${field.fieldName}`
                  : field.fieldName
              }
            >
              {field.fieldTitle.en}
            </option>
          );
        });
      }
    }
  };

  getSelectFieldUseAsOption = (values) => {
    return (
      <div className="form-check">
        <CustomRadio label="Use As Dropdown" isRadio={true}>
          <Field
            type="radio"
            className="form-check-input"
            name="refCollection.displayType"
            value={'dropdown'}
          />
        </CustomRadio>
        <CustomRadio
          label={values.isMultiSelect ? 'Use As Checkbox' : 'Use As Radio'}
          isRadio={true}
        >
          <Field
            type="radio"
            className="form-check-input"
            name="refCollection.displayType"
            value={'asRadioOrCheckbox'}
          />
        </CustomRadio>
        {this.props.selectedField === reference.id && (
          <CustomRadio label="Use As Text Field" isRadio={true}>
            <Field
              type="radio"
              className="form-check-input"
              name="refCollection.displayType"
              value={'asText'}
            />
          </CustomRadio>
        )}
      </div>
    );
  };

  getBelongsToFieldOption = (refCollectionId) => {
    if (refCollectionId) {
      const { projectCollections } = this.props;
      let index = projectCollections.findIndex(function (item, i) {
        return item.collectionName === refCollectionId;
      });
      if (index >= 0) {
        return projectCollections[index].fields.map((field) => {
          if (field.type === reference.id)
            return (
              <option key={field._id} value={field.fieldName}>
                {field.fieldTitle.en}
              </option>
            );
        });
      }
    }
  };

  getRestControls = (values, setFieldValue, setFieldTouched) => {
    const { selectedField } = this.props;
    if (selectedField === large_text.id) {
      return <LargeTextExtraSetting values={values} setFieldValue={setFieldValue} />;
    } else if (selectedField === dynamic_option.id) {
      return (
        <MultiDynamicExtraSetting
          validateRefCollectionId={this.validateRefCollectionId}
          collectionOptions={this.props.collectionOptions}
          values={values}
          getSelectFieldUseAsOption={this.getSelectFieldUseAsOption}
          getFieldOption={this.getFieldOption}
        />
      );
    } else if (selectedField === belongsTo.id) {
      return (
        <BelongsToExtraSetting
          validateRefCollectionId={this.validateRefCollectionId}
          collectionOptions={this.props.collectionOptions}
          values={values}
          getBelongsToFieldOption={this.getBelongsToFieldOption}
          getFieldOption={this.getFieldOption}
        />
      );
    } else if (selectedField === reference.id) {
      return (
        <ReferenceExtraSetting
          validateRefCollectionId={this.validateRefCollectionId}
          validateRefCollectionField={this.validateRefCollectionId}
          collectionOptions={this.props.collectionOptions}
          values={values}
          getFieldOption={this.getFieldOption}
          getSelectFieldUseAsOption={this.getSelectFieldUseAsOption}
        />
      );
    } else if (selectedField === static_option.id) {
      return (
        <StaticOptionExtraSetting
          tags={this.props.tags}
          handleTagDelete={this.props.handleTagDelete}
          handleTagAddition={this.props.handleTagAddition}
          getSelectFieldUseAsOption={this.getSelectFieldUseAsOption}
          values={values}
          setFieldValue={this.props.setFieldValue}
        />
      );
    } else if (selectedField === file.id) {
      return (
        <FileExtraSetting
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          getFileTypes={this.getFileTypes}
          values={values}
        />
      );
    } else if (selectedField === date.id) {
      return <DateExtraSetting />;
    } else if (selectedField === time_picker.id) {
      return <TimepickerExtraSetting />;
    } else if (selectedField === custom_uuid.id) {
      return (
        <CustomUUIDExtraSetting
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          values={values}
        />
      );
    }
  };
  handleChange = (name, value, setFieldValue) => {
    setFieldValue(name, value);
  };

  showEncryptionCheckbox = (isFilePrivate) => {
    const { values, setFieldValue, setFieldTouched, selectedField, projectDetail, fieldName } =
      this.props;
    const encryption = projectDetail && projectDetail.enableEncryption;

    if (!encryption) {
      return;
    }

    const allEncryption = [
      email.id,
      tel.id,
      large_text.id,
      number.id,
      date.id,
      static_option.id,
      dynamic_option.id,
      markdown.id,
      url.id,
    ].includes(selectedField);
    const notUsername = selectedField === text.id && fieldName !== 'userName';
    const fileEncryption = selectedField === file.id && isFilePrivate;
    if (allEncryption || notUsername || fileEncryption) {
      return (
        <Col6FormCheck>
          <CustomRadio label="Encrypted / PHI" isRadio={false}>
            <Field type="checkbox" name="encrypted" className="form-check-input" />
          </CustomRadio>
          <small>(Encrypted data / Protected Health Information (PHI))</small>
          <p className="errors">
            <ErrorMessage name="encrypted" />
          </p>
        </Col6FormCheck>
      );
    }
  };

  showURLCheckbox = (isFilePrivate, isFileEncrypted) => {
    if (isFilePrivate && !isFileEncrypted)
      return (
        <Col6FormCheck>
          <CustomRadio label="Generate URL" isRadio={false}>
            <Field type="checkbox" name="isGenerateURL" className="form-check-input" />
          </CustomRadio>
          <small>( Generate Signed URL.)</small>
          <p className="errors">
            <ErrorMessage name="isGenerateURL" />
          </p>
        </Col6FormCheck>
      );
  };

  showExtraPhoneFields = (selectedField) => {
    if (FieldTypes.tel.id !== selectedField) return '';
    return (
      <>
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
          <CustomInputWithIcon icon="select" extraCss="bmd-form-group">
            <Field name="extraFieldSetting.defaultCountry">
              {({ field, form, meta }) => (
                <>
                  <CustomSelect
                    name={field.name}
                    value={field.value}
                    options={phoneNumberCountryCode.map((code) => ({
                      label: code.name,
                      value: code.iso2,
                    }))}
                    placeholder="Default Country (Optional)"
                    onChange={(name, value) => form.setFieldValue(name, value)}
                  />
                  {meta.touched && meta.error && <p className="errors">{meta.error}</p>}
                </>
              )}
            </Field>
          </CustomInputWithIcon>
        </div>
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
          <CustomInputWithIcon icon="select" extraCss="bmd-form-group">
            <Field name="extraFieldSetting.allowedCountries">
              {({ field, form, meta }) => (
                <>
                  <CustomSelect
                    name={field.name}
                    isMulti={true}
                    value={field.value}
                    options={phoneNumberCountryCode.map((code) => ({
                      label: code.name,
                      value: code.iso2,
                    }))}
                    placeholder="Allowed Countries (Optional)"
                    onChange={(name, value) => form.setFieldValue(name, value)}
                  />
                  {meta.touched && meta.error && <p className="errors">{meta.error}</p>}
                </>
              )}
            </Field>
          </CustomInputWithIcon>
        </div>
      </>
    );
  };

  showPermissionRoles = () => {
    const { values, setFieldValue, setFieldTouched, roles = [] } = this.props;
    const roleOptions = roles.map((role) => ({
      value: role.name,
      label: role.name,
    }));
    return (
      <>
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
          <CustomInputWithIcon icon="select" extraCss="bmd-form-group">
            <CustomSelect
              name="readRoles"
              isMulti={true}
              value={values.readRoles}
              options={roleOptions}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Select roles that can read this field"
            />
            <p className="errors">
              <ErrorMessage name="readRoles" />
            </p>
          </CustomInputWithIcon>
        </div>
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
          <CustomInputWithIcon icon="select" extraCss="bmd-form-group">
            <CustomSelect
              name="writeRoles"
              isMulti={true}
              value={values.writeRoles}
              options={roleOptions}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Select roles that can write to this field"
            />
            <p className="errors">
              <ErrorMessage name="writeRoles" />
            </p>
          </CustomInputWithIcon>
        </div>
      </>
    );
  };

  render() {
    const {
      values,
      setFieldValue,
      setFieldTouched,
      selectedField,
      projectDetail,
      changeFieldType,
      isPluginField,
    } = this.props;
    const { toggleAdvancedField } = this.state;
    const dropdownForBoolean = () => {
      return [
        { label: 'True', value: true },
        { label: 'False', value: false },
      ];
    };
    const encryption = projectDetail && projectDetail.enableEncryption;
    return (
      <>
        <CollectionCardView bgColor="drapcode-violet" headTitle="Step #1: Choose Field Type">
          <div className="col-12 mx-auto mb-3 mt-3">
            {this.getFieldTypes()
              .sort((a, b) => a.sortOrder - b.sortOrder)
              .map((field) => (
                <div
                  className={`btn btn-sm mr-2 text-center ${
                    field.value === selectedField ? 'btn-theme-submit' : 'btn-outline-primary'
                  } ${isPluginField ? 'disabled' : ''}`}
                  onClick={() => {
                    if (!isPluginField) changeFieldType(field.value);
                  }}
                  style={customCss}
                  title={`Add ${field.label} Field Type`}
                  key={field.value}
                >
                  <strong>
                    <i className={`wb ${iconForField(field.value)}`}></i>
                    &nbsp; {field.label}&nbsp;
                  </strong>
                </div>
              ))}
            <div
              className={`btn btn-sm mr-2 text-center btn-outline-primary ${
                isPluginField ? 'disabled' : ''
              }`}
              onClick={() => {
                if (!isPluginField) this.setState({ toggleAdvancedField: !toggleAdvancedField });
              }}
              style={customCss}
            >
              <strong>
                <i className={`wb ${iconForField('advanced')}`}></i>
                &nbsp;Advanced&nbsp;
                <i
                  className={`wb webconnect-chevron-${toggleAdvancedField ? 'down' : 'right'}`}
                ></i>
              </strong>
            </div>
            {toggleAdvancedField &&
              this.getAdvancedFieldTypes()
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .map((field) => (
                  <div
                    className={`btn btn-sm mr-2 text-center ${
                      field.value === selectedField ? 'btn-theme-submit' : 'btn-outline-primary'
                    } ${isPluginField ? 'disabled' : ''}`}
                    onClick={() => {
                      if (!isPluginField) changeFieldType(field.value);
                    }}
                    style={customCss}
                    title={`Add ${field.label} Field Type`}
                    key={field.value}
                  >
                    <strong>
                      <i className={`wb ${iconForField(field.value)}`}></i>
                      &nbsp; {field.label}&nbsp;
                    </strong>
                  </div>
                ))}
          </div>
        </CollectionCardView>
        <CollectionCardView bgColor="drapcode-violet" headTitle="Step #2: Enter Field Details">
          <div className="row mx-auto mb-3 mt-3">
            <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
              <CustomInputWithIcon icon="text" required={true} extraCss="bmd-form-group">
                <Field
                  type="text"
                  name="fieldTitle.en"
                  className="form-control"
                  data-lang="en"
                  placeholder="Name Your Field"
                  maxLength={
                    values && values.extraFieldSetting && values.extraFieldSetting.maxLength
                      ? values.extraFieldSetting.maxLength
                      : undefined
                  }
                  onChange={(e) => this.handleFieldNameChange(e, setFieldValue)}
                  disabled={isPluginField}
                />
                <p className="errors">
                  <ErrorMessage name="fieldTitle.en" />
                </p>
              </CustomInputWithIcon>
            </div>
            {selectedField === boolean.id && !isPluginField && (
              <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
                <CustomInputWithIcon icon="select" extraCss="bmd-form-group">
                  <CustomSelect
                    name="extraFieldSetting.defaultValue"
                    isMulti={false}
                    isObject={false}
                    options={dropdownForBoolean()}
                    value={values ? getValuesForDefaultField(values) : ''}
                    placeholder="Default Fixed Value (Optional)"
                    onChange={(name, value) => this.props.setFieldValue(name, value)}
                  />
                  <p className="errors">
                    <ErrorMessage name="defaultValue" />
                  </p>
                </CustomInputWithIcon>
              </div>
            )}
            {TextTypeFields.includes(selectedField) && !isPluginField && (
              <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
                <CustomInputWithIcon icon="text" extraCss="bmd-form-group">
                  <Field
                    type="text"
                    name="extraFieldSetting.defaultValue"
                    className="form-control"
                    placeholder="Default Fixed Value (Optional)"
                    onChange={(e) => this.handleDefaultChange(e, setFieldValue)}
                  />
                  <p className="errors">
                    <ErrorMessage name="defaultValue" />
                  </p>
                </CustomInputWithIcon>
              </div>
            )}
            {this.showExtraPhoneFields(selectedField)}
            {!isPluginField && this.getRestControls(values, setFieldValue, setFieldTouched)}
            {[...TextTypeFields, color.id, url.id].includes(selectedField) && (
              <Col6FormCheck>
                <CustomRadio label="Unique" isRadio={false}>
                  <Field type="checkbox" name="unique" className="form-check-input" />
                </CustomRadio>
                <small>( Prevents submission of duplicate values, eg: email, SSN etc. )</small>
                <p className="errors">
                  <ErrorMessage name="unique" />
                </p>
              </Col6FormCheck>
            )}
            {selectedField === file.id && (
              <>
                <Col6FormCheck>
                  <CustomRadio label="Generate Icons" isRadio={false}>
                    <Field type="checkbox" name="isGenerateIcons" className="form-check-input" />
                  </CustomRadio>
                  <small>( Generate three icons of the file.)</small>
                  <p className="errors">
                    <ErrorMessage name="isGenerateIcons" />
                  </p>
                </Col6FormCheck>
                <Col6FormCheck>
                  <CustomRadio label="Private" isRadio={false}>
                    <Field type="checkbox" name="isPrivate" className="form-check-input" />
                  </CustomRadio>
                  <small>( Make the file Private.)</small>
                  <p className="errors">
                    <ErrorMessage name="isPrivate" />
                  </p>
                </Col6FormCheck>
              </>
            )}
            {this.showEncryptionCheckbox(values.isPrivate)}
            {this.showPermissionRoles()}
            {!isPluginField && this.showURLCheckbox(values.isPrivate, values.encrypted)}
            {SelectOptionFields.includes(selectedField) && !isPluginField && (
              <Col6FormCheck>
                <CustomRadio label="Multiple Select" isRadio={false}>
                  <Field type="checkbox" name="isMultiSelect" className="form-check-input" />
                </CustomRadio>
                <small>( Allow to choose multiple values )</small>
                <p className="errors">
                  <ErrorMessage name="isMultiSelect" />
                </p>
              </Col6FormCheck>
            )}
            {selectedField === reference.id && !isPluginField && (
              <>
                <Col6FormCheck>
                  <CustomRadio label="File Type" isRadio={false}>
                    <Field
                      type="checkbox"
                      name="refCollection.isFileType"
                      className="form-check-input"
                    />
                  </CustomRadio>
                  <p className="errors">
                    <ErrorMessage name="refCollection.isFileType" />
                  </p>
                </Col6FormCheck>
                {values.refCollection.isFileType && (
                  <FileExtraSetting
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    getFileTypes={this.getFileTypes}
                    values={values}
                  />
                )}
              </>
            )}
          </div>
        </CollectionCardView>
      </>
    );
  }
}
